module.exports = __webpack_public_path__ + "media/images/icon-svg/chevron-down-497d87ab9c9f3a8ba5b82a196b55093a.svg";